module.exports = __webpack_public_path__ + "assets/clever-insights-logo-component.2132d608.svg";